import React, {Component} from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_closeSession, _openModal, _removeModal, _clearPendingMFA, _setSsoToken} from '../../../store';
import {TextInput} from '../../../../shared';
import PropTypes from 'prop-types';
import axiosInstance from '../../../utils/axios';
import history from '../../../../history';
import Button from '../../Button';
import DescriptiveText from '../../DescriptiveText';
import Row from '../../Row';
import Checkbox from '../../Checkbox';
import {goHome, checkV3ReleaseModals} from '../../../utils/utils';
import {PORTAL_NAME} from '../../../../config';

class TwoFactorAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: '',
      isTrustedDevice: false,
      content: props.content,
      title: 'Two-Factor Authentication',
    };
  }

  updatePin = (name, value) => {
    this.setState({[name]: value});
  };

  toggleCheckbox = (name, value) => {
    this.setState({[name]: value});
  };

  submitPin = (pin, isTrustedDevice, email, content) => {
    axiosInstance.post(
      '/user/session/mfa',
      {pin, isTrustedDevice},
      content.linkingUser ? {headers: {'cb-email': content.session.profile.email, 'cb-token': content.session.token}} : null
    )
      .then(res => {
        if (res.data.trustedDeviceToken) {
          localStorage.setItem('trustedDeviceToken-' + email, res.data.trustedDeviceToken);
        }
        this.props.dispatchRemoveModal(content);
        this.props.clearPendingMFA();
        this.props.setSsoToken(null);

        if (content.onSuccess) {
          content.onSuccess();
        } else if (content.session.profile?.role) {
          goHome(content.session.profile.role);
        } else {
          history.push('/');
        }
        if (PORTAL_NAME === 'advisor' && this.state?.content?.session?.profile?.t3SurveyRequired) {
          this.props.dispatchOpenModal({
            type: 'T3SurveyModal',
          });
        }
        checkV3ReleaseModals(this.state?.content?.session?.profile);
      })
      .catch((err) => {
        this.props.dispatchOpenModal({
          type: 'Error',
          title: 'Authentication Error',
          err,
        });
      });
  };

  resendPin = content => {
    axiosInstance.put(
      '/user/session/mfa',
      {},
      content.linkingUser ? {headers: {'cb-email': content.session.profile.email, 'cb-token': content.session.token}} : null
    )
      .then(() => {
        this.props.dispatchOpenModal({
          type: 'MessageModal',
          title: 'MFA Authentication',
          body: 'Your PIN was resent.',
        });
      })
      .catch((err) => {
        this.props.dispatchOpenModal({
          type: 'Error',
          title: 'Authentication Error',
          err,
        });
      });
  };

  cancel = content => {
    this.props.dispatchRemoveModal(content);
    if (content.linkingUser) {
      return axiosInstance.delete(
        '/user/session',
        {headers: {'cb-email': content.session.profile.email, 'cb-token': content.session.token}}
      );
    }
    this.props.logout();
  }

  render() {
    const {pin, isTrustedDevice, content, title} = this.state;
    const {mfaMessage, email} = this.props.content;

    return (
      <BaseModal onClose={() => this.cancel(content)} title={title}>
        <div>
          <DescriptiveText>{mfaMessage}</DescriptiveText>
        </div>
        <form onSubmit={(event) => {
          event.preventDefault();
          this.submitPin(pin, isTrustedDevice, email, content);
        }}>
          <TextInput
            dataPoint={{name: 'pin', value: pin}}
            type='text'
            title='Verification PIN'
            placeholder='Enter Pin...'
            onChange={this.updatePin}
            required>
          </TextInput>
          <Checkbox onChange={this.toggleCheckbox}
                    dataPoint={{name: 'isTrustedDevice', value: !!this.state.isTrustedDevice}}
                    title={'Add as trusted device.'}/>
          <Row wrap={true}>
            <Button
              width={'auto'}
              importance={'primary'}
              size={'lg'}
              label={'Verify'}
              disabled={false}
              action={'SUBMIT'}>
            </Button>
            <Button
              width={'auto'}
              importance={'secondary'}
              size={'lg'}
              label={'Cancel'}
              disabled={false}
              action={() => this.cancel(content)}>
            </Button>
            <Button
              width={'auto'}
              importance={'secondary'}
              size={'lg'}
              label={'Resend Pin'}
              disabled={false}
              action={() => this.resendPin(content)}>
            </Button>
          </Row>
        </form>
      </BaseModal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
  dispatchOpenModal: modal => {
    dispatch(_openModal(modal));
  },
  setSsoToken: ssoToken => {
    dispatch(_setSsoToken(ssoToken));
  },
  logout: options => {
    dispatch(_closeSession(options));
  },
  clearPendingMFA: () => {
    dispatch(_clearPendingMFA());
  },
});

export default connect(null, mapDispatchToProps)(TwoFactorAuth);

TwoFactorAuth.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    componentName: PropTypes.string.isRequired,
    mfaMessage: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    session: PropTypes.object,
    linkingUser: PropTypes.bool,
    onSuccess: PropTypes.func,
  }),
  dispatchRemoveModal: PropTypes.func.isRequired,
  dispatchOpenModal: PropTypes.func.isRequired,
  clearPendingMFA: PropTypes.func.isRequired,
  setSsoToken: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};
